export default (value: Date) => {
    // Convert to a date object
    const date = new Date(value);
    // Declare the formatter to display in UTC timezone, but only show the date
    const formatter = new Intl.DateTimeFormat('en-GB', {
        timeZone: 'UTC',
        month: '2-digit',
        day: '2-digit',
        year: 'numeric'
    });
    // Format the date as above
    return formatter.format(date);
}